import { useState } from "react";
import { BadgePercent, ShieldCheck, ArrowRight, Clock } from "lucide-react";
import { useVeteranDiscount, getVerifiedDiscount } from "@/lib/veteran";
import { VeteranVerifyModal } from "@/components/VeteranVerifyModal";

function daysLeft(endDate) {
  if (!endDate) return null;
  const end = new Date(endDate + "T23:59:59");
  if (isNaN(end)) return null;
  return Math.ceil((end - new Date()) / 86400000);
}

export function VeteranDiscountBanner() {
  const cfg = useVeteranDiscount();
  const [verify, setVerify] = useState(false);
  const [verified, setVerified] = useState(getVerifiedDiscount());
  if (!cfg || !cfg.enabled) return null;

  const note = cfg.note ? cfg.note : "any eligible ATF WebWorks offer";
  const dl = daysLeft(cfg.end_date);
  const countdown = dl == null || dl < 0 ? null
    : dl === 0 ? "Ends today" : dl === 1 ? "Ends tomorrow" : `Ends in ${dl} days`;

  return (
    <div className="border border-gold/30 bg-gold/[0.07] px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="veteran-discount-banner">
      <BadgePercent className="text-gold shrink-0" size={24} />
      <p className="text-sm text-gray-200 leading-relaxed flex-1">
        <span className="font-semibold text-white">Thank you for your service.</span> Every veteran and transitioning service member gets{" "}
        <span className="text-gold font-semibold">{cfg.percent}% off</span> {note}.
        {cfg.require_verification ? (
          verified ? (
            <> Your code: <span className="text-gold font-semibold tracking-wide" data-testid="veteran-discount-code">{verified.code}</span> — enter it at checkout.</>
          ) : (
            <> Verify your service to unlock your personal code.</>
          )
        ) : (
          cfg.code ? <> Use code <span className="text-gold font-semibold tracking-wide" data-testid="veteran-discount-code">{cfg.code}</span> at checkout or just let us know on your assessment.</> : null
        )}
        {countdown && (
          <span className="inline-flex items-center gap-1 text-gold font-semibold ml-1" data-testid="veteran-discount-countdown">
            <Clock size={13} /> {countdown}
          </span>
        )}
      </p>
      {cfg.require_verification && !verified && (
        <button onClick={() => setVerify(true)} data-testid="veteran-verify-btn"
          className="shrink-0 inline-flex items-center gap-1.5 bg-gold text-navy px-4 py-2 text-sm font-semibold hover:bg-gold-light transition-colors">
          <ShieldCheck size={15} /> Verify your service <ArrowRight size={14} />
        </button>
      )}
      {verify && (
        <VeteranVerifyModal percent={cfg.percent} onVerified={(d) => setVerified(d)} onClose={() => setVerify(false)} />
      )}
    </div>
  );
}
